import { __assign } from "tslib";
import React from 'react';
import ErrorBoundary from '.';
export function withErrorBoundary(Component, debugComponent) {
    var decorated = function (props) { return (React.createElement(ErrorBoundary, { debugComponent: debugComponent },
        React.createElement(Component, __assign({}, props)))); };
    decorated.displayName = "withErrorBoundary(".concat(Component.displayName || 'Component', ")");
    return decorated;
}
//# sourceMappingURL=withErrorBoundary.js.map